import { render, staticRenderFns } from "./BookComments.vue?vue&type=template&id=1d3bb904&"
import script from "./BookComments.vue?vue&type=script&lang=js&"
export * from "./BookComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports